import React, { useEffect, useState } from "react";
// ES6
import {
  SwitchTransition,
  TransitionGroup,
  CSSTransition,
} from "react-transition-group";

import "./Nav.css";
type endpointsListT = {
  [key: string]: string;
};

interface NavProps {
  onNavClickHandle: (url: string, title: string) => void;
  items: endpointsListT;
}

const mapToPolish = {
  material: 'materiał',
  color: 'kolor',
  luvers: 'OCZKA',
  window: 'okno',
  parameters: 'parametry',
  summary: 'streszczenie'
} as any;


function Nav(props: NavProps) {
  const [items, setItems] = useState(Object.keys(props.items) as any[]);
  const [itemsForReturn, setItemsForReturn] = useState([] as any[]);
  const [nextItems, setnextItems] = useState([] as any[]);
  const [nextItemsInitLength, setNextItemsInitLength] = useState(0);
  const [isPrev, setIsPrev] = useState(false);
  const [progressBar, setProgressBar] = useState(0);
  let itemWidth = 0;
  const stepWidth = 150;
  
 
  useEffect(() => {
    const firstElInit = Object.keys(props.items)[0];
    props.onNavClickHandle(props.items[firstElInit], firstElInit);
    setnextItems(Object.keys(props.items).splice(1));
    setNextItemsInitLength(Object.keys(props.items).splice(1).length);
    setItems([firstElInit]);
  }, [props.items]);

  useEffect(() => {
    setProgressBar(100 - (nextItems.length / nextItemsInitLength) * 100);
  }, [nextItems]);
  return (
    <div className="Nav">
      <div className="Nav-progress-bar">
        <div
          className="Nav-progress-bar-inner"
          style={{ width: `${progressBar}%` }}
        ></div>
      </div>
      <div className="Nav-prev">
        <ul className="Nav-prev-list">
          <TransitionGroup component={null}>
            {itemsForReturn.map((el) => (
              <CSSTransition
                key={el}
                timeout={300}
                in={true}
                classNames={isPrev ? "item-pr" : "item"}
              >
                <li
                  onClick={() => props.onNavClickHandle(props.items[el], el)}
                  className="Nav-prev-item"
                  key={el}
                >
                  {mapToPolish[el]}
                </li>
              </CSSTransition>
            ))}
          </TransitionGroup>
        </ul>
      </div>
      <div className="Nav-current">
        <ul className="Nav-current-list">
          <li className="Nav-current-item Nav-current-btn-item">
            {" "}
            <div className="btn-step-box">
              <button
                className="btn-step btn-step-prev"
                onMouseEnter={() => setIsPrev(true)}
                onClick={() => {
                  if (itemsForReturn.length) {
                    const item = itemsForReturn.splice(0, 1).pop();
                    const currentItem = items.splice(0, 1).pop();
                    items.push(item);
                    nextItems.unshift(currentItem);
                    setItemsForReturn([...itemsForReturn]);
                    setnextItems([...nextItems]);
                    setItems([...items]);
                    props.onNavClickHandle(props.items[item], item);
                  }
                  setItems([...items]);
                }}
              >
                <i className="icofont-curved-left"></i>
              </button>
              <button
                className="btn-step btn-step-next"
                onMouseEnter={() => setIsPrev(false)}
                onClick={() => {
                  if (nextItems.length > 0) {
                    const item = nextItems.splice(0, 1).pop();
                    const currentItem = items.splice(0, 1).pop();
                    itemsForReturn.unshift(currentItem);
                    items.push(item);
                    setItemsForReturn([...itemsForReturn]);
                    setnextItems([...nextItems]);
                    setItems([...items]);
                    props.onNavClickHandle(props.items[item], item);
                  }
                }}
              >
                <i className="icofont-curved-right"></i>
              </button>
            </div>
          </li>
          {/* <CSSTransition   key={1}
               timeout={500}
               in={true}
               classNames="item">WOW</CSSTransition> */}
          <TransitionGroup>
            <CSSTransition
              key={items[0]}
              timeout={300}
              in={true}
              classNames={isPrev ? "item-pr" : "item"}
            >
              <li
                // onClick={() =>
                //   props.onNavClickHandle(props.items[items[0]], items[0])
                // }
                className="Nav-current-item"
                key={items[0]}
              >
                {mapToPolish[items[0]]}
              </li>
            </CSSTransition>
          </TransitionGroup>
        </ul>
      </div>
      <div className="Nav-next">
        <ul className="Nav-next-list">
          <TransitionGroup component={null}>
            {nextItems.map((el, i) => {
              return (
                <CSSTransition
                  key={el}
                  timeout={300}
                  in={true}
                  classNames={isPrev ? "item-pr" : "item"}
                >
                  <li
                    style={{
                      transform: `translateX(${
                        i > 0 ? (itemWidth += stepWidth) : itemWidth
                      }px`,
                    }}
                    onClick={() => {
                      const index = nextItems.findIndex((nextEl) => nextEl === el)
                      const tempitems = nextItems.splice(0, index)
                      const indexAfterChange = nextItems.findIndex((nextEl) => nextEl === el)
                      const itemToCurrent = nextItems.splice(indexAfterChange, 1)
                      itemsForReturn.unshift(items.pop())
                      items.push(itemToCurrent)
                      tempitems.forEach((el) => {
                        itemsForReturn.unshift(el);
                      })
                      setItemsForReturn([...itemsForReturn]);
                      setnextItems([...nextItems]);
                      setItems([...items]);
                      props.onNavClickHandle(props.items[el], el);
                    }}
                    className="Nav-next-item"
                    key={el}
                  >
                    {mapToPolish[el]}
                  </li>
                </CSSTransition>
              );
            })}
          </TransitionGroup>
        </ul>
      </div>
    </div>
  );
}

export default Nav;
